export default "__VITE_ASSET__aRzcIbxc__"